import React from "react";
import CarrouselComponent from '../../components/Carrousel/Carrousel';
import PorQueElegirnos from '../../components/PorQueElegirnos/PorQueElegirnos';
import NuestrosProductos from "../../components/NuestrosProductos/NuestrosProductos";
import Footer from "../../components/Footer/Footer";


const Home = () => {
    return (
        <div>
            <CarrouselComponent />
            <PorQueElegirnos />
            <NuestrosProductos />
            <Footer />
        </div>
    );
};

export default Home;
